// src/docs/DocsProjectStatus.js
import React from "react";
import { Container, Typography, Box } from "@mui/material";

const DocsProjectStatus = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      {/* Page Title */}
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 3 }}>
        Project Status
      </Typography>

      {/* Introduction */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 3 }}>
        On CrowdLaunch, each project is assigned a status that reflects its current phase and operational state.
        The status is influenced by the token sale timeline, funding performance, and actions taken by the project owner or platform administrators.
      </Typography>

      {/* Active Projects */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Active Projects
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        A project is considered <strong>Active</strong> when its token sale is in progress. During this phase:
        <br />• The project is accepting contributions.
        <br />• Investors can purchase tokens at a fixed rate.
        <br />• The sale is ongoing, and the funding goals (soft cap/hard cap) have not yet been fully met or finalized.
      </Typography>

      {/* Expired Projects */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Expired Projects
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        A project becomes <strong>Expired</strong> once its token sale period ends. At this point:
        <br />• If the soft cap is reached, the project is finalized and the raised funds are transferred to the project owner.
        <br />• If the soft cap is not met, refunds may be enabled, allowing investors to reclaim their contributions.
      </Typography>

      {/* Cancelled Projects */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Cancelled Projects
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        A project is marked as <strong>Cancelled</strong> when:
        <br /><br />
        <strong>User-Initiated Cancellation:</strong>
        <br />• The project owner may cancel the sale by calling the <code>cancelSale()</code> function.
        <br /><br />
        <strong>Platform-Initiated Cancellation:</strong>
        <br />• If a project is reported by multiple users for issues such as fraud or misrepresentation,
        the platform may cancel the project for investor protection by invoking <code>factoryCancelSale()</code> or <code>adminCancelSale()</code>.
      </Typography>


      {/* Conclusion */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mt: 3 }}>
        Being aware of a project's status is critical for both project creators and investors. It informs you of whether the project is currently
        active, has expired (with the potential for refunds), or has been cancelled. Always verify the status on CrowdLaunch to ensure you understand
        the current stage and what actions are available.
      </Typography>
    </Container>
  );
};

export default DocsProjectStatus;
